import React from 'react'
import GptSearchbar from './GptSearchbar'
import GptMovieSugg from './GptMovieSugg'

const GPTSearch = () => {
  return (
    <div>
        <GptSearchbar/>
        <GptMovieSugg/>
    </div>
  )
}

export default GPTSearch